import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/biweekly-savings-calculator',
  component: () => import('../../routes/BiweeklySavingsCalculator.svelte'),
  card: {
    id: 'biweekly-savings-calculator',
    title: 'Biweekly Savings Calculator',
    description: 'Discover how splitting your monthly savings into biweekly deposits earns you an extra month each year — automatically. Compare with monthly savings.',
    icon: 'calendar_view_week',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/biweekly-savings-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Biweekly Savings Calculator – Double Your Savings Without Extra Effort',
    description: 'Free biweekly savings calculator to see how depositing half your monthly savings every two weeks earns you an extra month per year. Compare with monthly deposits and see year-by-year projections at any APY.',
  },
};

export default meta;
